import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";


const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    if (!loading && !user) {
      setShowDialog(true);
    }
  }, [loading, user]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <span className="text-xl">Loading...</span>
      </div>
    );
  }

  if (!user) {
    return (
      <>
        {showDialog && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <h2 className="text-xl font-semibold">Access Denied</h2>
              <p className="mt-2 text-gray-600">
                You need to log in to access this page.
              </p>
              <button
                onClick={() => (window.location.href = "/login")}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
              >
                Go to Login
              </button>
            </div>
          </div>
        )}
        <Navigate to="/login" />
      </>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
